export default {"src":"/_next/static/media/ic-pack.bcee27b5.svg","height":48,"width":24,"blurWidth":0,"blurHeight":0};